import { render, staticRenderFns } from "./checkforgot.vue?vue&type=template&id=7ce9a4e0&"
import script from "./checkforgot.vue?vue&type=script&lang=js&"
export * from "./checkforgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports